import api from '../_api';

const actions = {
    getSeasons: ({commit}) => {

        return new Promise((resolve, reject) => {
            commit('RESET_STATE');
            commit('DRAW_LOADING');

            api.getSeasons()
                .then((resp) => {
                    commit('SEASONS_SUCCESS', resp.data.data);
                    resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('DRAW_ERROR', errors);
                    reject(err.response);
                });
        })
    },
    getDivisions: ({commit}, payload) => {

        return new Promise((resolve, reject) => {
            commit('DRAW_LOADING');

            api.getDivisions(payload.seasonId)
                .then((resp) => {
                    commit('DIVISIONS_SUCCESS', resp.data.data);
                    resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('DRAW_ERROR', errors);
                    reject(err.response);
                });
        })
    },
    getTeams: ({commit}, payload) => {

        return new Promise((resolve, reject) => {
            commit('DRAW_LOADING');

            api.getTeams(payload.divisionId)
                .then((resp) => {
                    commit('TEAMS_SUCCESS', resp.data.data);
                    resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('DRAW_ERROR', errors);
                    reject(err.response);
                });
        })
    },
    getDraw: ({commit}, payload) => {

        return new Promise((resolve, reject) => {
            commit('DRAW_LOADING');

            api.getDraw(payload.divisionId)
                .then((resp) => {
                    commit('DRAW_SUCCESS', resp.data.data);
                    resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('DRAW_ERROR', errors);
                    reject(err.response);
                });
        })
    },
    getResult: ({commit}, payload) => {

        return new Promise((resolve, reject) => {
            commit('DRAW_LOADING');

            api.getResult(payload.divisionId)
                .then((resp) => {
                    commit('RESULT_SUCCESS', resp.data.data);
                    resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('DRAW_ERROR', errors);
                    reject(err.response);
                });
        })
    },
    clearDrawErrors:({commit}) => {
        commit('CLEAR_DRAW_ERRORS');
    },
}

export default actions
